import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ChartTitle, WidgetTitle } from "../../../../Constants/Constants";
import MonthlyHistory from "./MonthlyHistory";
import ProjectCreated from "./ProjectCreated";
import SalesOverview from "./SalesOverview";
import TotalSale from "./TotalSale";
import LiveProducts from "./LiveProducts";
import TurnOver from "./TurnOver";
import CryptocurrencyPrices from "./CryptocurrencyPrices";
import CryptoAnnotations from "./CryptoAnnotations";
import StockMarket from "./StockMarket";
import Finance from "./Finance";
import OrderStatus from "./OrderStatus";
import MonthlySales from "./MonthlySales";
import UsesChart from "./Uses";
import { Fragment } from "react/jsx-runtime";

const ChartContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ChartTitle} parent={WidgetTitle} />
      <Container fluid>
        <Row>
          <TotalSale />
        </Row>
        <Row>
          <ProjectCreated />
          <SalesOverview />
          <MonthlyHistory />
        </Row>
        <Row>
          <LiveProducts />
          <TurnOver />
          <CryptocurrencyPrices />
          <CryptoAnnotations />
        </Row>
        <Row>
          <StockMarket />
          <Finance />
          <OrderStatus />
          <MonthlySales/>
          <UsesChart/>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ChartContainer;
